import _ from "lodash";
import "flatpickr"
import { createAutoCompleteInput } from './break_bulk/autocomplete-input';
import "select2";


$(() => {
  createAutoCompleteInput();

  const computeVariables = _.debounce(() => {
    $(".volume").val($(".length").val() * $(".width").val() * $(".height").val() * $(".units").val())
    $(".gross_weight").val($(".weight").val() * $(".units").val())
  }, 1000);

  $(".number_input").on('input', function (e) {
    computeVariables(e.target.value)
  });

  $(".cargo_readiness").flatpickr({
    enableTime: false,
    noCalendar: false,
    dateFormat: "d/m/Y",
    minDate: Date.now(),
    allowInput: true
  });

  $("#attachment").on('change', function () {
    $("#attachment_name").text(this.files[0].name)
  })

  $("#break_bulk_request_cargo_type").select2({
    minimumResultsForSearch: Infinity, // Disable search/autocomplete
    templateResult: formatOption,
    selectionCssClass: "break_bulk_selection",
    dropdownCssClass: "break_bulk_selection"
  })

  $("#break_bulk_request_packaging_type").select2({
    minimumResultsForSearch: Infinity, // Disable search/autocomplete
    templateResult: formatOption,
    selectionCssClass: "break_bulk_selection",
    dropdownCssClass: "break_bulk_selection"
  })

  function formatOption(option) {
    if (!option.id) {
      return option.text;
    }

    let subtitle = $(option.element).data('subtitle');

    let container = $(
      `
      <div class="break_bulk_selection">
        <div class="select2-option-container">
          <div class="select2-option-text">
           <div class="select2-option-title">${option.text}</div> 
           ${subtitle ? `<div class="select2-option-subtitle">${subtitle}</div>` : ""}
          </div>
        </div>
      </div>
      `
    );

    return container;
  }
});